// frontend/src/components/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children, adminOnly = false }) {
  const { token, user, loading } = useAuth();

  // Mientras se verifica auth, no mostramos nada
  if (loading) return null;

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !user.is_admin) {
    alert("Acceso denegado. Se requieren permisos de administrador.");
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;